import { response } from "app/helpers/commonInterface";
import {
  GET_CLIENT_ADVANCE_PAYMENT_FAILURE,
  GET_CLIENT_ADVANCE_PAYMENT_REQUEST,
  GET_CLIENT_ADVANCE_PAYMENT_SUCCESS,
} from "../actionTypes";
import { billData } from "./billingDataInterface";
import { transactionData, transactionDetail } from "../transaction/transactionDataInterface";

export interface advancePaymentState{
  loading: boolean;
  advancePayments: response<transactionDetail[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: advancePaymentState = {
  loading: false,
  advancePayments: {},
  error: "",
};

export const getClientAdvancePaymentsReducer = (
  state = initialState,
  action: action
) => {
  switch (action.type) {
    case GET_CLIENT_ADVANCE_PAYMENT_REQUEST:
      return {
        loading: true,
      };
    case GET_CLIENT_ADVANCE_PAYMENT_SUCCESS:
      return {
        loading: false,
        advancePayments: action.payload,
        error: "",
      };
    case GET_CLIENT_ADVANCE_PAYMENT_FAILURE:
      return {
        loading: false,
        advancePayments: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
